import brandingService, { type Theme } from "BrandingService";
import global from "Global";
import type { ThemeOptions } from "wtg-material-ui";
import themeHelper from "./ThemeConfiguration.ts";

let themeConfiguration: Theme | undefined;

export function clearLastRefreshedTheme(): void {
  themeConfiguration = undefined;
}

export function getLastRefreshedTheme(): Theme | undefined {
  return themeConfiguration;
}

export async function refreshThemeOptionsAsync(): Promise<ThemeOptions | undefined> {
  if (!global.materialDesign || global.portalInfo.frameworkVersion < 4) {
    themeConfiguration = undefined;
    return;
  }

  themeConfiguration = await brandingService.fetchCurrentUserThemeAsync();
  themeHelper.convertDrawerOptionsToBrandOptions(themeConfiguration?.configuration, global.moduleName !== "NEO");
  return themeConfiguration?.configuration;
}
